/* TIGRAR - Desktop mega menu hover interaction
 * Adds hover intent while preserving Dawn click and keyboard behavior.
 */

(() => {
  const hoverMedia = window.matchMedia(
    '(min-width: 990px) and (hover: hover) and (pointer: fine)'
  );

  const menuDetails = document.querySelectorAll(
    '.tigrar-header-menu header-menu > details'
  );

  if (!menuDetails.length) return;

  const openDelay = 120;
  const closeDelay = 300;

  menuDetails.forEach((details) => {
    let openTimer;
    let closeTimer;

    details.addEventListener('pointerenter', () => {
      if (!hoverMedia.matches) return;

      window.clearTimeout(closeTimer);

      openTimer = window.setTimeout(() => {
        menuDetails.forEach((otherDetails) => {
          if (otherDetails !== details) {
            otherDetails.removeAttribute('open');
          }
        });

        details.setAttribute('open', '');
      }, openDelay);
    });

    details.addEventListener('pointerleave', () => {
      if (!hoverMedia.matches) return;

      window.clearTimeout(openTimer);

      closeTimer = window.setTimeout(() => {
        details.removeAttribute('open');
      }, closeDelay);
    });
  });
})();